import axiosClient from "../axiosClient";
const getToken = () => {
  return (
    (localStorage?.auth && JSON.parse(localStorage.auth)?.accessToken) ||
    undefined
  );
};

const getPackages = (params, thunkAPI) => {
  return axiosClient.get("permission/package", {
    signal: thunkAPI?.signal,
    params,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  });
};

export { getPackages };
